import {createAction, handleActions} from 'redux-actions';
import {Map/*, List, fromJS, setIn*/} from 'immutable';
// import {pender} from 'redux-pender';
// import * as api from 'lib/api';

const SET_PLUS_OPT = 'guide/SET_PLUS_OPT';
const RE_CALC = 'guide/RE_CALC';

export const setPlusOpt = createAction(SET_PLUS_OPT);
export const reCalc = createAction(RE_CALC);

const initialState = Map({
  plsuUpNoti: Map({
    plusFilter1: '0', //의상종류 
    plusFilter2: '0', //업글등급
    plusFilter3: '0', //아이템등급
    plusUpKitPrice: '2500', //완플
    plusUpKitPriceNor: '430', //일플
    reCalc: '0'
  })
});

export default handleActions({
  [SET_PLUS_OPT]: (state, action) => {
    const {name, value} = action.payload;
    
    return state.setIn(['plsuUpNoti', name], value)
  },
  [RE_CALC]: (state, action) => {
    const curr = state.getIn(['plsuUpNoti', 'reCalc']);
    return state.setIn(['plsuUpNoti', 'reCalc'], curr === '0' ? '1' : '0');
  }
}, initialState);